import { AccountHolderType, AccountType, BankAccountInfo } from "src/api";
import { BankAccountHolderTypeValues, BankAccountTypeValues, BankAccountHolderType, BankAccountType } from "./types";
import { FieldState } from "formstate";

export const accountTypesFromForm = (achDetail: {
    accountType: FieldState<"" | BankAccountTypeValues>,
    accountHolderType: FieldState<"" | BankAccountHolderTypeValues>,
}): [AccountType, AccountHolderType, BankAccountHolderType] => {
    const effectiveAccountType = achDetail.accountType.$.trim() === BankAccountType.Savings ? BankAccountType.Savings : BankAccountType.Checking;
    const effectiveAccountHolderType = achDetail.accountHolderType.$.trim() === BankAccountHolderType.Business ? BankAccountHolderType.Business : BankAccountHolderType.Personal;

    const accountType = effectiveAccountType === BankAccountType.Savings ? AccountType.NUMBER_1 : AccountType.NUMBER_0;
    const accountHolderType = effectiveAccountHolderType === BankAccountHolderType.Business ? AccountHolderType.NUMBER_1 : AccountHolderType.NUMBER_0;

    return [accountType, accountHolderType, effectiveAccountHolderType];
}

export const formAccountTypesFromExisting = (bankAccount: Partial<BankAccountInfo>) : 
    [BankAccountTypeValues | '', BankAccountHolderTypeValues | ''] => {
    let accountType: (BankAccountTypeValues | '') = '';
    let accountHolderType: (BankAccountHolderTypeValues | '') = '';
    
    if(typeof bankAccount.accountType === 'number') {
        accountType = bankAccount.accountType === AccountType.NUMBER_1 ? BankAccountType.Savings : BankAccountType.Checking;
    }

    if(typeof bankAccount.accountHolderType === 'number') {
        accountHolderType = bankAccount.accountHolderType === AccountHolderType.NUMBER_1 ? BankAccountHolderType.Business : BankAccountHolderType.Personal;
    }

    return [accountType, accountHolderType];
}
